/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../store/actions";
import { i18n } from '../../../../translate/i18n';
import { FormControl, Button, IconButton, Box } from '@mui/material';
import { FilterList } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';
import { IAutocompleteOption } from '../../../../models/iautocompleteOption';
import { RootState } from '../../../../store/types';

type Props = {
  closeModal: CallableFunction,
}

const UsersFiltersModal: React.FC<Props> = (props) => {
	const dispatch = useDispatch();
	const [selectedRoles, setSelectedRoles] = useState<IAutocompleteOption[]>([]);
	const [searchTextRole, setSearchTextRole] = useState<string>('');

	const [searchTextCompanies, setSearchTextCompanies] = useState<string>('');
	const [companiesFormated, setCompaniesFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedCompanies, setSelectedCompanies] = useState<IAutocompleteOption[]>([]);

	const page = 1;
	const limit = 30;
	const orderBy = "name";
	const order = "asc";

	const roles = [
    {
      value: 'admin',
      label: 'Administrador',
    },
    {
      value: 'analyst',
      label: 'Analista',
    },
    {
      value: 'contractor',
      label: 'Empresa Terceira',
    }
  ];

	const filteredRoles = useSelector((state: RootState) => state.scheduledServices.filtersUsers.roles);
	const filteredCompanies = useSelector((state: RootState) => state.scheduledServices.filtersUsers.companies);
	const role = useSelector((state: any) => state.auth.selectedAccess.role);
	const companies = useSelector((state: RootState) => state.scheduledServices.companies);
	const loadingCompanies = useSelector((state: RootState) => state.scheduledServices.loadingCompanies);

	const fetchCompanies = useCallback(
		() => dispatch(actions.scheduledServicesFetchCompanies(page, limit, searchTextCompanies, order, orderBy)),
		[page, limit, searchTextCompanies, order, orderBy]
	);

	useEffect(() => {
		setSelectedRoles(filteredRoles);
		setSelectedCompanies(filteredCompanies);
	}, []);

	useEffect(() => {
		if (role !== 'contractor') {
      fetchCompanies();
    }
	}, [searchTextCompanies]);

	useEffect(() => {
		setCompaniesFormated(
			companies.map((company) => ({ value: company._id, label: company.name }))
		)
	}, [companies])
	
	const handleInputChangeSelectorRoles = (text: string) => {
		setSearchTextRole(text);
	}

	const handleInputChangeRoles = (selectedRoles: IAutocompleteOption[]) => {
		if (selectedRoles) {
			setSelectedRoles(selectedRoles);
		} else {
			setSelectedRoles([]);
		}
	}

	const handleInputChangeCompanies = (selected: IAutocompleteOption[]) => {
		if (selected) {
			setSelectedCompanies(selected);
		} else {
			setSelectedCompanies([]);
		}
	}

	const handleInputChangeSelectorCompanies = (text: string) => {
		setSearchTextCompanies(text);
	}
	
	const handleClickFilter = () => {
		dispatch(actions.scheduledServicesSetUsersFilters({ roles: selectedRoles, companies: selectedCompanies }));
		props.closeModal();
	}

	const handleClickClearFilters = () => {
    setSelectedRoles([]);
	}

	return (

			<Box sx={styles.container}>			
				<Box sx={styles.headerContainer}>
					<Box sx={styles.titleContainer}>
						<FilterList sx={{ marginRight: '1rem' }} />
						{i18n.t('scheduledServicesUsersFilterModal.filter') as string}
						{(selectedRoles && selectedRoles.length > 0) &&
							<Box sx={styles.clearFilter} onClick={handleClickClearFilters}>{i18n.t('scheduledServicesUsersFilterModal.clear') as string}</Box>
						}
					</Box>
					<IconButton onClick={() => props.closeModal()} size="large">
						<CloseIcon />
					</IconButton>
				</Box>
			
				<Box style={styles.bodyContainer}>
					<FormControl variant="standard" fullWidth margin='normal'>
						<Autocomplete
							label={i18n.t('scheduledServicesUsersFilterModal.role')}
							data={roles}
							onSelectValue={handleInputChangeRoles}
							valueSelected={selectedRoles}
							newSearchText={handleInputChangeSelectorRoles}
							isMulti
						/>
					</FormControl>
					{ role !== 'contractor' && <FormControl variant="standard" fullWidth margin='normal'>
						<Autocomplete
							loading={loadingCompanies}
							label={i18n.t('scheduledServicesServicesForSchedulingFilterModal.company')}
							data={companiesFormated}
							onSelectValue={handleInputChangeCompanies}
							valueSelected={selectedCompanies}
							newSearchText={handleInputChangeSelectorCompanies}
							isMulti
						/>
					</FormControl>}
				</Box>

				<Box style={styles.footerContainer}>
					<Box
						onClick={() => props.closeModal()}
						sx={styles.buttonCancel}
					>
					{i18n.t('scheduledServicesUsersFilterModal.cancel') as string}
					</Box>
					<Button
						variant='contained'
						color='primary'
						onClick={handleClickFilter}
						sx={styles.button}
					>
					{i18n.t('scheduledServicesUsersFilterModal.ok') as string}
					</Button>
				</Box>
			</Box>

    );
}

const styles = {
	container: {
		width: '40rem',
		height: '100%'
	},
	headerContainer: {
		height: '5rem',
		padding: '0 1rem 0 2rem',
		backgroundColor: 'green',
		color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
	},
	titleContainer: {
		display: 'flex',
		alignItems: 'center',
		fontSize: '1.25rem'
	},
	bodyContainer: {
		height: 'calc(100% - 10rem)',
		padding: '1rem 2rem',
		overflowY: 'auto' as 'auto',
		borderTop: '1px solid #ccc',
		borderBottom: '1px solid #ccc',
	},
	footerContainer: {
		height: '5rem',
		padding: '0 2rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	button: {
		flex: 1,
		backgroundColor: 'green',
		borderRadius: '2rem',
		padding: '0.5rem 1.5rem',
	},
	buttonCancel: {
		flex: 1,
		cursor: 'pointer',
		color: 'grey',
		alignItems: 'center',
		textAlign: 'center',
	},
	clearFilter: {
		fontSize: '1rem', 
		marginLeft: '2rem', 
		color: '#fff', 
		cursor: 'pointer', 
		textDecoration: 'underline' 
	}
}


export default UsersFiltersModal;

